'use client';

import React from 'react';

import { RatingStrategy } from '@/api/copy-trading/types';
import { CardsSlider, SlideData } from '@/blocks/components/CardsSlider';

import { TradersCard } from '@/app/[lang]/copy-trade/(shared)/TradersCard';

import styles from './styles.module.scss';

interface StrategiesSliderProps {
  tops: RatingStrategy[];
}

const renderCard = (card: RatingStrategy, slideData: SlideData) => (
  <TradersCard {...card} {...slideData} showAwardsBadge={true} />
);

export default function StrategiesSlider({ tops }: StrategiesSliderProps) {
  return (
    <CardsSlider
      items={tops}
      renderCard={renderCard}
      itemKey={'strategyId'}
      classes={{ slide: styles.slide }}
    />
  );
}
